import AlertMessageContent from 'components/feedback/AlertMessageContent';

import type { ResetPasswordAlertCopy } from './resetPasswordMessages';

const ResetPasswordAlertMessage = ({ message }: { message: ResetPasswordAlertCopy }) => (
    <AlertMessageContent
        message={message}
        classNames={{
            root: 'ResetPasswordPage__alertContent',
            title: 'ResetPasswordPage__alertTitle',
            paragraph: 'ResetPasswordPage__alertParagraph',
            spacer: 'ResetPasswordPage__alertSpacer',
            spacerSize: size => `ResetPasswordPage__alertSpacer--${size}`,
        }}
    />
);

export default ResetPasswordAlertMessage;
